var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBallad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3364 10.5C26.3546 10.5 18.1787 -2.86434 11.1668 8.59303C18.1732 -2.86434 1.82131 -2.86434 8.83318 8.59303C1.8268 -2.86434 -6.34915 10.5 7.66362 10.5C-6.35464 10.5 1.82131 23.8643 8.83318 12.407C1.8268 23.8643 18.1787 23.8643 11.1668 12.407C18.1732 23.8695 26.3491 10.5 12.3364 10.5Z",
    fill: "#1DDFEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallad);
export default __webpack_public_path__ + "static/media/ballad.131d681820a9d0a9a5bcb9edd87809d0.svg";
export { ForwardRef as ReactComponent };